/**
 * Route for `igaming-audit-ready-logs`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingAuditReadyLogsPage } from "../features/igaming-audit-ready-logs/IgamingAuditReadyLogsPage";

export const igamingAuditReadyLogsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-audit-ready-logs",
	component: IgamingAuditReadyLogsPage,
});

export default igamingAuditReadyLogsRoute;
